/**
 * Typed wrappers around /api/job-roles. Every path-bearing call MUST
 * encodeURIComponent(name) — the server decodes via decodeURIComponent.
 */
import { apiFetch } from "./api";

async function readJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      // ignore
    }
    const err = new Error(`api ${res.status}`) as Error & { status: number; body: unknown };
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return (await res.json()) as T;
}

export async function listJobRoles(): Promise<string[]> {
  const res = await apiFetch("/api/job-roles");
  return readJson<string[]>(res);
}

export async function createJobRole(name: string): Promise<string> {
  const res = await apiFetch("/api/job-roles", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ name }),
  });
  return readJson<string>(res);
}

export async function renameJobRole(oldName: string, newName: string): Promise<string> {
  const res = await apiFetch(`/api/job-roles/${encodeURIComponent(oldName)}`, {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ name: newName }),
  });
  return readJson<string>(res);
}

export async function deleteJobRole(name: string): Promise<void> {
  const res = await apiFetch(`/api/job-roles/${encodeURIComponent(name)}`, { method: "DELETE" });
  if (!res.ok) {
    throw new Error(`api ${res.status}`);
  }
}
